import { render, staticRenderFns } from "./Reveal.vue?vue&type=template&id=b90bdc9c&scoped=true&"
import script from "./Reveal.vue?vue&type=script&lang=js&"
export * from "./Reveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90bdc9c",
  null
  
)

export default component.exports